import type {RelationshipConstraint} from '@packages/systems/constraints-types';
export const SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS: RelationshipConstraint[] =
  [
    {is: 'DynamoWrapper', rule: 'Forbid'},
    {is: 'LocalesWrapper', rule: 'Forbid'},
    {is: 'SearchResultWrapper', rule: 'Forbid'},
    {is: 'CommerceCartWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutFormContainer', rule: 'Forbid'},
    {is: 'CommerceOrderConfirmationContainer', rule: 'Forbid'},
    {is: 'CommercePaypalCheckoutFormContainer', rule: 'Forbid'},
    {is: 'UserAccountWrapper', rule: 'Forbid'},
    {is: 'UserAccountSubscriptionListWrapper', rule: 'Forbid'},
  ];

export const SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS: RelationshipConstraint[] =
  [
    {is: 'DynamoWrapper', rule: 'Forbid'},
    {is: 'LocalesWrapper', rule: 'Forbid'},
    {is: 'SearchResultWrapper', rule: 'Forbid'},
    {is: 'CommerceCartWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutFormContainer', rule: 'Forbid'},
    {is: 'CommerceOrderConfirmationContainer', rule: 'Forbid'},
    {is: 'CommercePaypalCheckoutFormContainer', rule: 'Forbid'},
    {is: 'UserAccountWrapper', rule: 'Forbid'},
    {is: 'UserAccountSubscriptionListWrapper', rule: 'Forbid'},
  ];
